class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    // NO agregar el listener de input aquí - se agregará al botón Apply
    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);

    // Agregar listener al botón Apply
    this.setupApplyButton();
  }

  setupApplyButton() {
    const applyButton = document.getElementById('ApplyFilters');
    if (applyButton) {
      applyButton.addEventListener('click', (event) => {
        event.preventDefault();
        const facetForm = this.querySelector("form");
        if (facetForm) {
          // Crear un evento sintético para que funcione con el código existente
          const syntheticEvent = new Event('submit', { bubbles: true, cancelable: true });
          Object.defineProperty(syntheticEvent, 'target', { value: facetForm, enumerable: true });
          Object.defineProperty(syntheticEvent, 'srcElement', { value: facetForm, enumerable: true });
          this.onSubmitHandler(syntheticEvent);

          // Cerrar el drawer después de aplicar
          const collectionSection = document.querySelector('collection-section');
          if (collectionSection && typeof collectionSection.toggleDrawer === 'function') {
            setTimeout(() => {
              collectionSection.toggleDrawer();
            }, 300);
          }
        }
      });
    }
  }

  connectedCallback() {
    const facetForm = this.querySelector("form");
    if (facetForm) {
      facetForm.addEventListener("input", this.checkApplyButtonState.bind(this));
    }

    // Initial check
    this.checkApplyButtonState();

    // Smart collapse initialization
    this.handleSmartCollapse();
  }

  checkApplyButtonState() {
    const applyButton = document.getElementById('ApplyFilters');
    if (!applyButton) return;

    const form = this.querySelector('form');
    if (!form) return;

    const hasChecked = form.querySelector('input[type="checkbox"]:checked');

    if (hasChecked) {
      applyButton.removeAttribute('disabled');
      applyButton.classList.remove('disabled');
    } else {
      applyButton.setAttribute('disabled', 'true');
      applyButton.classList.add('disabled');
    }
  }

  handleSmartCollapse() {
    const filters = this.querySelectorAll('.js-filter');

    filters.forEach(filter => {
      const list = filter.querySelector('.list--checkbox');
      const header = filter.querySelector('.filter__header');

      if (!list || !header) return;

      const children = Array.from(list.children);
      if (children.length === 0) return;

      const style = window.getComputedStyle(list);
      const gap = parseFloat(style.columnGap) || 0;
      const padding = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);

      let totalWidth = 0;
      children.forEach((child, index) => {
        totalWidth += child.offsetWidth;
        if (index < children.length - 1) {
          totalWidth += gap;
        }
      });

      // El ancho disponible para los elementos es el ancho interno del contenedor (clientWidth)
      // menos el padding total (ya que clientWidth incluye el padding).
      const availableWidth = list.clientWidth - padding;

      if (totalWidth <= availableWidth) {
        header.classList.add('dropdown--disabled');
      } else {
        header.classList.remove('dropdown--disabled');
      }
    });
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static fireCustomEvent(options) {
    const facetsChange = new CustomEvent("facets:change", {
      bubbles: true,
      cancelable: true,
      detail: {
        desc: "facets changed",
        ...options,
      },
    });
    document.dispatchEvent(facetsChange);
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;

    const sections = FacetFiltersForm.getSections();
    // const countContainer = document.getElementById("ProductCount");
    // const countContainerDesktop = document.getElementById(
    //   "ProductCountDesktop",
    // );
    // document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    // if (countContainer) {
    //   countContainer.classList.add('loading');
    // }
    // if (countContainerDesktop) {
    //   countContainerDesktop.classList.add('loading');
    // }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static showFilterLoader() {
    document.querySelector('.collection__filter-loader')?.classList.add('is-visible');
  }

  static hideFilterLoader() {
    document.querySelector('.collection__filter-loader')?.classList.remove('is-visible');
  }

  static renderSectionFromFetch(url, event) {
    FacetFiltersForm.showFilterLoader();
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];

        const parser = new DOMParser();
        const parsedHTML = parser.parseFromString(html, 'text/html')
        const newActiveFilters = parsedHTML.querySelector('[active-filters]')?.innerText?.replace('var activeFilters = ', '');
        if (newActiveFilters) activeFilters = JSON.parse(newActiveFilters);

        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        // FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === "function")
          initializeScrollAnimationTrigger(html.innerHTML);
      })
      .finally(() => FacetFiltersForm.fireCustomEvent());
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    // FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === "function")
      initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    // Actualizar el grid de productos
    document.getElementById("ProductGridContainer").innerHTML =
      parsedHTML.getElementById("ProductGridContainer").innerHTML;

    // Manejar el mensaje de "no products"
    const collectionSection = document.querySelector('collection-section');
    const existingEmptyMessage = collectionSection ?
      collectionSection.parentElement.querySelector('.collection-empty') : null;
    const newEmptyMessage = parsedHTML.querySelector('.collection-empty');

    if (newEmptyMessage) {
      // Hay un mensaje de "no products" en la respuesta
      if (existingEmptyMessage) {
        // Actualizar el mensaje existente
        existingEmptyMessage.innerHTML = newEmptyMessage.innerHTML;
        existingEmptyMessage.style.display = '';
      } else {
        // Crear el mensaje nuevo
        if (collectionSection) {
          collectionSection.parentElement.insertAdjacentHTML('beforeend', newEmptyMessage.outerHTML);
        }
      }
    } else {
      // No hay mensaje de "no products", ocultar si existe
      if (existingEmptyMessage) {
        existingEmptyMessage.style.display = 'none';
      }
    }

    FacetFiltersForm.hideFilterLoader();
  }

  static renderProductCount(html) {
    const count = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductCount").innerHTML;
    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");
    container.innerHTML = count;
    container.classList.remove("loading");
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove("loading");
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    const facetDetailsElements = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter",
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index
        : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element),
    );
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      // const newElement = document.createElement(element.tagName);
      // newElement.innerHTML = element.innerHTML;
      const newElement = element;

      const tabIndexElements = newElement.querySelectorAll(
        ".wt-collapse__trigger",
      );
      tabIndexElements.forEach((el) => el.setAttribute("tabindex", "0"));

      const container = document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`,
      );

      if (container) {
        container.innerHTML = ""; // clear existing content
        container.appendChild(newElement); // append new element
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    FacetFiltersForm.updateFilterBadge(parsedHTML);

    if (countsToRender)
      FacetFiltersForm.renderCounts(
        countsToRender,
        event.target.closest(".js-filter"),
      );

    // Re-check apply button state and smart collapse
    const facetFiltersForm = document.querySelector('facet-filters-form');
    if (facetFiltersForm) {
      if (typeof facetFiltersForm.checkApplyButtonState === 'function') {
        facetFiltersForm.checkApplyButtonState();
      }
      if (typeof facetFiltersForm.handleSmartCollapse === 'function') {
        facetFiltersForm.handleSmartCollapse();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [".active-facets"];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      ".mobile-facets__open",
      ".mobile-facets__count",
      ".sorting",
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });

    // document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector(".facets__selected");
    const sourceElement = source.querySelector(".facets__selected");

    const targetElementAccessibility = target.querySelector(".facets__summary");
    const sourceElementAccessibility = source.querySelector(".facets__summary");

    if (sourceElement && targetElement) {
      target.querySelector(".facets__selected").outerHTML =
        source.querySelector(".facets__selected").outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector(".facets__summary").outerHTML =
        source.querySelector(".facets__summary").outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`,
    );
  }

  static updateFilterBadge(parsedHTML) {
    // Buscar el badge en el HTML actualizado
    const newBadge = parsedHTML.querySelector('.wt-filter__trigger__counter');
    const currentBadge = document.querySelector('.wt-filter__trigger__counter');
    const filterTrigger = document.querySelector('.wt-filter__trigger');

    if (!filterTrigger) return;

    // Si hay un nuevo badge en el HTML actualizado
    if (newBadge) {
      const count = newBadge.textContent.trim();

      if (currentBadge) {
        // Actualizar el badge existente
        currentBadge.textContent = count;
      } else {
        // Crear un nuevo badge
        const badge = document.createElement('span');
        badge.className = 'wt-filter__trigger__counter';
        badge.textContent = count;
        filterTrigger.appendChild(badge);
      }
    } else {
      // Si no hay badge en el HTML actualizado, removerlo si existe
      if (currentBadge) {
        currentBadge.remove();
      }
    }
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    const params = new URLSearchParams();

    for (const [key, value] of formData.entries()) {
      params.append(key, value);
    }

    return params.toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();

    const sortFilterForms = document.querySelectorAll(
      "facet-filters-form form",
    );
    if (event.srcElement.className === "mobile-facets__checkbox") {
      const searchParams = this.createSearchParams(
        event.target.closest("form"),
      );
      this.onSubmitForm(searchParams, event);

    } else {
      const forms = [];
      const isMobile =
        event.target.closest("form").id === "FacetFiltersFormMobile";

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (
            form.id === "FacetSortForm" ||
            form.id === "FacetFiltersForm" ||
            form.id === "FacetSortDrawerForm"
          ) {
            const noJsElements = document.querySelectorAll(".no-js-list");
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === "FacetFiltersFormMobile") {
          forms.push(this.createSearchParams(form));
        }
      });

      const searchParams = forms.join("&");

      const formatted = this.formatFilterValues(searchParams);

      if (window.analyticsUtils && window.analyticsUtils.pushFilteredValuesToDataLayer) {
        window.analyticsUtils.pushFilteredValuesToDataLayer(formatted.keys, formatted.values);
      }

      this.onSubmitForm(searchParams, event);
    }
  }

  getFilterValues(searchParams) {
    const params = new URLSearchParams(searchParams);
    const filters = {};

    for (const [key, value] of params.entries()) {
      if (!filters[key]) {
        filters[key] = [];
      }
      filters[key].push(value);
    }

    return filters;
  }
  formatFilterValues(searchParams) {
    const params = new URLSearchParams(searchParams);
    const filters = {
      talla: [],
      color: [],
      precio: null
    };

    let minPrice = null;
    let maxPrice = null;

    for (const [key, value] of params.entries()) {
      // Extract "talla" (size)
      if (key.includes('filtro_talla_ropa')) {
        filters.talla.push(value);
      } else if (key.includes('color_base')) {
        filters.color.push(value);
      } else if (key.includes('price.gte')) {
        minPrice = value;
      } else if (key.includes('price.lte')) {
        maxPrice = value;
      }
    }

    if (minPrice !== null && maxPrice !== null) {
      filters.precio = `${minPrice}€-${maxPrice}€`;
    }

    const keys = [];
    const values = [];

    if (filters.talla.length > 0) {
      keys.push('talla');
      values.push(filters.talla.join('|'));
    }

    if (filters.color.length > 0) {
      keys.push('color');
      values.push(filters.color.join('|'));
    }

    // if (filters.precio) {
    //   keys.push('precio');
    //   values.push(filters.precio);
    // }

    return {
      keys: keys.join('|'),
      values: values.join('|'),
      raw: filters
    };
  }


  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf("?") === -1
        ? ""
        : event.currentTarget.href.slice(
          event.currentTarget.href.indexOf("?") + 1,
        );
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) =>
      element.addEventListener("input", this.onRangeChange.bind(this)),
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("max", maxInput.value.trim());
    if (minInput.value) maxInput.setAttribute("min", minInput.value.trim());
    if (minInput.value === "") maxInput.setAttribute("min", 0);
    if (maxInput.value === "")
      minInput.setAttribute("max", maxInput.getAttribute("max"));
  }

  adjustToValidValues(input) {
    const fromInput = this.querySelector('[name="filter.v.price.gte"]');
    const toInput = this.querySelector('[name="filter.v.price.lte"]');
    const sliderEl = this.querySelector(".f-price__slider");

    const globalMax = sliderEl
      ? Number(sliderEl.dataset.max) || 999999
      : 999999;

    let fromValue = parseFloat(fromInput.value) || 0;
    let toValue = parseFloat(toInput.value) || 0;

    if (input.name === "filter.v.price.gte") {
      if (fromValue < 0) {
        fromValue = 0;
      }
      if (fromValue > toValue) {
        fromValue = toValue;
      }
      if (fromValue > globalMax) {
        fromValue = globalMax;
      }
      fromInput.value = fromValue;
    } else {
      if (toValue < fromValue) {
        toValue = fromValue;
      }
      if (toValue > globalMax) {
        toValue = globalMax;
      }
      toInput.value = toValue;
    }
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector("a") || this.querySelector("button");
    if (!facetLink) return;

    facetLink.setAttribute("role", "button");
    facetLink.addEventListener("click", this.closeFilter.bind(this));
    facetLink.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.closeFilter(event);
      }
    });
    FacetFiltersForm.fireCustomEvent();
  }

  closeFilter(event) {
    const target = event.currentTarget;

    // Si el elemento tiene data-url (como nuestro nuevo botón Borrar Filtros), usamos esa URL directamente por AJAX
    const url = target.dataset.url;

    if (url) {
      event.preventDefault();
      const searchParams = url.includes("?") ? url.split("?")[1] : "";
      FacetFiltersForm.renderPage(searchParams, event);
      return;
    }

    // Comportamiento original para otros filtros
    const isRemoveAllButton = event.target.closest('.wt-filter__clear-all') ||
      event.target.classList.contains('wt-filter__remove-all');

    if (isRemoveAllButton) {
      // Si no hay data-url pero es el botón de borrar, no paramos el evento (fallback)
      return;
    }

    event.preventDefault();
    const form =
      this.closest("facet-filters-form") ||
      document.querySelector("facet-filters-form");
    const priceRanges = document.querySelectorAll(
      ".f-price__inputs > .f-price__val",
    );

    if (
      (event.target.className === "filter__remove" ||
        event.target.parentNode.classList.contains("price_range")) &&
      priceRanges
    ) {
      const priceSlider = document.querySelector(".f-price__slider");

      if (priceSlider) {
        const maxPrice = document
          .querySelectorAll("price-range > div")[0]
          .getAttribute("data-max");
        const minPriceRange = priceRanges[0].querySelector("input");
        const maxPriceRange = priceRanges[1].querySelector("input");

        priceSlider.noUiSlider.set([
          priceSlider.dataset.min,
          priceSlider.dataset.max,
        ]);

        minPriceRange.value = 0;
        minPriceRange.max = maxPrice;

        maxPriceRange.value = maxPrice;
        maxPriceRange.min = 0;
      }
    }
    form.onActiveFilterClick(event);
  }
}

customElements.define("facet-remove", FacetRemove);